import { useMemo } from 'react'
import { useLocalStorage } from 'react-use'

import { LabsFlag } from '../enums/labsFlag'

export type LabsMenuFlags = Record<LabsFlag, boolean>

export const useLabsMenuFlags = (): LabsMenuFlags => {
  const [bankReconciliationFlag] = useLocalStorage(LabsFlag.ReactBankReconciliation, 0)
  const [reactBillsFlag] = useLocalStorage(LabsFlag.ReactBills, 0)
  const [navigationMyClient] = useLocalStorage(LabsFlag.NavigationMyClient, 0)
  const [mastercardOpenFinanceFlag] = useLocalStorage(LabsFlag.MastercardOpenFinance, 0)
  const [reportsFlag] = useLocalStorage(LabsFlag.Reports, 0)
  const [cashPilotOpenBankFlag] = useLocalStorage(LabsFlag.CashPilotOpenBank, 0)
  const [expertReportsSuppliersBalanceFlag] = useLocalStorage(LabsFlag.ExpertReportsSuppliersBalance, 0)
  const [expertReportsCustomersBalanceFlag] = useLocalStorage(LabsFlag.ExpertReportsCustomersBalance, 0)
  const [expertReportsTrialBalanceFlag] = useLocalStorage(LabsFlag.ExpertReportsTrialBalance, 0)
  const [expertReportsProfitAndLossFlag] = useLocalStorage(LabsFlag.ExpertReportsProfitAndLoss, 0)
  const [expertReportsBalanceSheetFlag] = useLocalStorage(LabsFlag.ExpertReportsBalanceSheet, 0)
  const [expertReportsVatDeclarationsFlag] = useLocalStorage(LabsFlag.ExpertReportsVatDeclarations, 0)
  const [expertReviewEntriesFlag] = useLocalStorage(LabsFlag.ExpertReviewEntries, 0)
  const [importedInvoicesFlag] = useLocalStorage(LabsFlag.ImportedInvoices, 0)
  const [importedInvoiceReviewFlag] = useLocalStorage(LabsFlag.ImportedInvoiceReview, 0)
  const [reconciliationViewAsDefaultFlag] = useLocalStorage(LabsFlag.ReconciliationViewAsDefault, 0)
  const [invoicingSettingsFlag] = useLocalStorage(LabsFlag.InvoicingSettings, 0)

  return useMemo(
    () => ({
      [LabsFlag.ReactBankReconciliation]: !!bankReconciliationFlag,
      [LabsFlag.ReactBills]: !!reactBillsFlag,
      [LabsFlag.NavigationMyClient]: !!navigationMyClient,
      [LabsFlag.MastercardOpenFinance]: !!mastercardOpenFinanceFlag,
      [LabsFlag.Reports]: !!reportsFlag,
      [LabsFlag.CashPilotOpenBank]: !!cashPilotOpenBankFlag,
      [LabsFlag.ExpertReportsSuppliersBalance]: !!expertReportsSuppliersBalanceFlag,
      [LabsFlag.ExpertReportsCustomersBalance]: !!expertReportsCustomersBalanceFlag,
      [LabsFlag.ExpertReportsTrialBalance]: !!expertReportsTrialBalanceFlag,
      [LabsFlag.ExpertReportsProfitAndLoss]: !!expertReportsProfitAndLossFlag,
      [LabsFlag.ExpertReportsBalanceSheet]: !!expertReportsBalanceSheetFlag,
      [LabsFlag.ExpertReportsVatDeclarations]: !!expertReportsVatDeclarationsFlag,
      [LabsFlag.ExpertReviewEntries]: !!expertReviewEntriesFlag,
      [LabsFlag.ImportedInvoices]: !!importedInvoicesFlag,
      [LabsFlag.ImportedInvoiceReview]: !!importedInvoiceReviewFlag,
      [LabsFlag.ReconciliationViewAsDefault]: !!reconciliationViewAsDefaultFlag,
      [LabsFlag.InvoicingSettings]: !!invoicingSettingsFlag,
    }),
    [
      bankReconciliationFlag,
      reactBillsFlag,
      navigationMyClient,
      mastercardOpenFinanceFlag,
      reportsFlag,
      cashPilotOpenBankFlag,
      expertReportsSuppliersBalanceFlag,
      expertReportsCustomersBalanceFlag,
      expertReportsTrialBalanceFlag,
      expertReportsProfitAndLossFlag,
      expertReportsBalanceSheetFlag,
      expertReportsVatDeclarationsFlag,
      expertReviewEntriesFlag,
      importedInvoicesFlag,
      importedInvoiceReviewFlag,
      reconciliationViewAsDefaultFlag,
      invoicingSettingsFlag,
    ],
  )
}
